import { render, staticRenderFns } from "./InvitacionesPasoZona.vue?vue&type=template&id=2d0cedbb"
import script from "./InvitacionesPasoZona.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesPasoZona.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports